export default "__VITE_ASSET__3af49806__"